import { inject } from 'aurelia-dependency-injection';
import { customAttribute } from 'aurelia-templating';
import { bindable } from 'aurelia-typed-observable-plugin';
import { FocusTrap } from '@material/dom/focus-trap';
import '../aurelia-typed-observable-plugin-fix';

@customAttribute('mdc-focus-trap')
@inject(Element)
export class MdcFocusTrap {
  constructor(private root: HTMLElement) { }

  focusTrap?: FocusTrap;

  @bindable.booleanAttr
  delay: boolean;

  @bindable.none
  initialFocusEl?: HTMLElement | (() => HTMLElement);

  @bindable.booleanAttr
  skipInitialFocus: boolean;

  @bindable.booleanAttr
  skipRestoreFocus: boolean;

  attached() {
    if (!this.delay) {
      this.create();
    }
  }

  create() {
    let initialFocusEl: HTMLElement | undefined;
    if (this.initialFocusEl instanceof HTMLElement || this.initialFocusEl === undefined) {
      initialFocusEl = this.initialFocusEl as HTMLElement | undefined;
    } else {
      initialFocusEl = this.initialFocusEl();
    }
    this.focusTrap = new FocusTrap(this.root, { initialFocusEl, skipInitialFocus: this.skipInitialFocus, skipRestoreFocus: this.skipRestoreFocus });
  }

  trapFocus() {
    this.focusTrap?.trapFocus();
  }

  releaseFocus() {
    this.focusTrap?.releaseFocus();
  }
}
